export enum PlatformLinkingStatus {
  InProgress,
  Success,
  Failed,
  PuuidMissing,
}
